import Amplify from '@aws-amplify/core';

export const configure = (config: any, isVerbose?: boolean) => {
	if (isVerbose) {
		console.debug('[SSOAuth][configure]', config);
	}
	Amplify.configure(config);
};
